import { doPrivatePostRequest } from "./requests"

export const getDetailedByDocId = (_doc_id, _token) => {
    const path = '/meets-detailed/get'
    const params = {
        'st': 'DOC-ID',
        'sk': _doc_id,
    }
    return doPrivatePostRequest(params, path, _token)
}

export const getDetailedByMeetsId = (_doc_id, _token) => {
    const path = '/meets-detailed/get'
    const params = {
        'st': 'BY-MEETS-ID',
        'sk': _doc_id,
    }
    return doPrivatePostRequest(params, path, _token)
}